/**
 * Note: Before developing this content, you must first define the theme token values of light and dark of the component.
 */
import { generateDynamicThemeToken } from '../../ThemeProvider';
import { getThemeToken } from './theme';
import { randomStr } from '../../Shared';
const componentName = 'Skeleton';
const classPrefix = `ui-Skeleton`;
/**
 * The classes here are the independent classes of the react-ui component.
 * It is mainly isolated from the classes of the mui component.
 * Avoid style conflicts when mui and react-ui are used simultaneously in project applications.
 *
 * On the way to develop react-ui components based on mui,
 * you must use this react-ui classes instead of mui classes.
 * You can control the built-in classes of the mui component through the classes prop of mui component.
 */
export const skeletonClasses = {
    // It is recommended that the root classname of the react-ui component be added with a random string.
    // This is mainly to avoid classname naming conflicts in the application
    root: `${classPrefix}-root-${randomStr()}`,
    container: `${classPrefix}-container-${randomStr()}`,
    text: `${classPrefix}-text`,
};
/**
 * All style css codes of react-ui components are centrally managed in this method through classes.
 * Through this method, the light and dark themes of the components can be controlled.
 * You don't need to care about the implementation of theme switching.
 * You only need to define the specified style value based on the content of the token.
 */
export function getStyle(theme, opts) {
    const dynamicToken = getThemeToken(theme);
    // generateThemeToken will return two contents, one is token data, and the other is tk method.
    // The token includes the light and dark theme style values defined by this component,
    // and it will automatically switch the token content of light or dark according to the outer ThemeProvider.
    // The role of tk is to process custom theme configuration,
    // and override the application custom token to the default light or dark token.
    const [token, tk] = generateDynamicThemeToken({
        componentName,
        theme,
        dynamicToken,
    });
    const { size = 'medium', variant = 'text' } = opts;
    return {
        [`&.${skeletonClasses.root}`]: {
            background: tk(token.background.n),
            height: tk(token.height[size]),
            width: variant === 'circular' ? tk(token.height[size]) : '100%',
            ...(['text', 'rounded'].includes(variant) && {
                borderRadius: tk(token.borderRadius[size]),
            }),
            transform: 'scale(1)',
            marginBottom: tk(token.marginBottom[size]),
        },
    };
}
